import Vue from 'vue';

/**
 * Registra todos os componentes
 */
Vue.component('XApp', () => import('./App'));
Vue.component('XAuthenticator', () => import('./Authenticator'));
Vue.component('XCard', () => import('./Card'));
Vue.component('XChartCard', () => import('./ChartCard'));
Vue.component('XCodeBlock', () => import('./CodeBlock'));
Vue.component('XCodeView', () => import('./CodeBlock/CodeView'));
Vue.component('XContainer', () => import('./Container'));
Vue.component('XCrudCard', () => import('./CrudCard'));
Vue.component('XCrudDetail', () => import('./CrudDetail'));
Vue.component('XCrudGrid', () => import('./CrudGrid'));
Vue.component('XViewFrame', () => import('./ViewFrame'));
Vue.component('XCrudView', () => import('./CrudView'));
Vue.component('XDataTable', () => import('./DataTable'));
Vue.component('XDataView', () => import('./DataView'));
Vue.component('XViewFrameChildren', () => import('./ViewFrameChildren'));
Vue.component('XDataViewChildren', () => import('./DataViewChildren'));
Vue.component('XHierarchicalGridNew', () => import('./HierarchicalGridNew'));
Vue.component('XFooterbar', () => import('./FooterBar'));
Vue.component('XFormBuilder', () => import('./FormBuilder'));
Vue.component('XGrid', () => import('./Grid'));
Vue.component('XHistoryPanel', () => import('./NavigationPanel/HistoryPanel'));
Vue.component('XInputField', () => import('./InputField'));
Vue.component('XMessenger', () => import('./Messenger'));
Vue.component('XModulesPanel', () => import('./NavigationPanel/ModulesPanel'));
Vue.component('XModulesPanelTree', () => import('./NavigationPanel/ModulesPanelTree'));
Vue.component('XNavbar', () => import('./NavBar'));
Vue.component('XNavBtn', () => import('./NavBar/NavButton'));
Vue.component('XNavigationPanel', () => import('./NavigationPanel'));
Vue.component('XNavLogoPanel', () => import('./NavBar/NavLogoPanel'));
Vue.component('XNavUserPanel', () => import('./NavBar/NavUserPanel'));
Vue.component('XPageView', () => import('./PageView'));
Vue.component('XQuickbar', () => import('./QuickBar'));
Vue.component('XShortBtn', () => import('./ShortBtn'));
Vue.component('XShowMessage', () => import('./ShowMessage'));
Vue.component('XSidebar', () => import('./SideBar'));
Vue.component('XTab', () => import('./Tab'));
Vue.component('XTabTest', () => import('./TabTest'));
Vue.component('XToolbar', () => import('./Toolbar'));
Vue.component('XToolbarTest', () => import('./ToolbarTest'));
Vue.component('XTranslator', () => import('./Translator'));
Vue.component('XTreeMenu', () => import('./TreeMenu'));
Vue.component('XTreeView', () => import('./TreeView/index.vue')); 